import Cookies from "universal-cookie";

import { TCognitoUserInfo } from "../types/TCognitoUserInfo";

export default class User {
	private readonly cookies = new Cookies();

	private username: string | null;
	private cognitoInfo: TCognitoUserInfo = {};

	constructor() {
		this.loadFromCookies();
	}

	private refreshCookies(): void {
		const data = {
			email: this.username,
			uid: this.cognitoInfo.uid,
			key: this.cognitoInfo.key,
			identityId: this.cognitoInfo.identityId,
		};
		this.cookies.set("authData", data, { domain: "sendum.com", path: "/" });
	}

	private loadFromCookies(): void {
		const authData = this.cookies.get("authData");
		if (authData) {
			this.username = authData.email;
			this.cognitoInfo.identityId = authData.identityId;
			this.cognitoInfo.uid = authData.uid;
			this.cognitoInfo.key = authData.key;
		}
	}

	public getUsername(): string | null {
		return this.username;
	}

	public setUsername(username: string): void {
		this.username = username;
		this.refreshCookies();
	}

	public isAuthorized(): boolean {
		return !!this.username && !!this.cognitoInfo.identityId && !!this.cognitoInfo.uid && !!this.cognitoInfo.key;
	}

	public getCognitoInfo(): TCognitoUserInfo {
		return this.cognitoInfo;
	}

	public updateCognitoInfo(info: TCognitoUserInfo): void {
		this.cognitoInfo = { ...this.cognitoInfo, ...info };
		this.refreshCookies();
	}

	public refresh(): void {
		this.loadFromCookies();
	}

	public logout(): void {
		this.cookies.remove("authData", { domain: "sendum.com", path: "/" });
		this.username = null;
		this.cognitoInfo = {};
		window.location.href = "/";
	}
}
